import { render, staticRenderFns } from "./ModalSelectSurveyQuestion.vue?vue&type=template&id=a6bab8d2&"
import script from "./ModalSelectSurveyQuestion.vue?vue&type=script&lang=js&"
export * from "./ModalSelectSurveyQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports